import { Pipe, PipeTransform } from '@angular/core';
import { NotificationLevel } from '@/app/platform/platform-data/models/notification-level';
import { BootstrapColor } from '@/types/css-variables.types';

const map: { [key in NotificationLevel]: BootstrapColor } = {
  [NotificationLevel.Danger]: 'danger',
  [NotificationLevel.Info]: 'info',
  [NotificationLevel.Success]: 'success',
  [NotificationLevel.Unknown]: 'white',
  [NotificationLevel.Warning]: 'warning'
};

@Pipe({
    name: 'notificationLevelColor',
    standalone: false
})
export class NotificationLevelColorPipe implements PipeTransform {
  transform(value: NotificationLevel): BootstrapColor {
    return map[value];
  }
}
